import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BuyerDashboardNew.css';
import './BuyerDashboard.css';
import './DashboardGlobal.css';
import { getCurrentUser, refresh } from '../../services/auth.service';
import BuyerDemosAvailable from './BuyerDemos_Available';
import BuyerDemosUpcoming from './BuyerDemos_Upcoming';
import BuyerDemosIncomplete from './BuyerDemos_Incomplete';
import BuyerDemosCompleted from './BuyerDemos_Completed';
import BuyerDemosRescheduled from './BuyerDemos_Rescheduled';
import BuyerDemosPending from './BuyerDemos_Pending';
import {
  resendEmailVerification,
  isVerified,
  getUserEmail,
  getUserProfile,
  refreshToken,
  getUserCompany,
  getBuyerUnreadMessages,
  addUserEventTracking,
  getSiteNotification,
  updateUser,
  getBuyerDeclinedReasons,
  getDemoCheckIn,
  addDemoCheckIn,
  getBuyerWorkspace,
  getBuyerObjections,
  getUpcomingEvents,
  hasExclusiveRequest,
  getUserAvailablePoints
} from '../../utils/api';
import FadeIn from '../../utils/fadein';
import Spinner from '../../components/layout/Spinner';
import { Link } from 'react-router-dom';
import { FaClock, FaUser, FaEdit, FaListOl, FaCreditCard, FaRegEnvelopeOpen, FaUsers, FaRegCalendarAlt, FaRegEdit, FaRegCalendarCheck, FaRegCalendarTimes, FaRegCircle, FaRegCheckCircle, FaRegComments, FaEnvelopeOpen, FaTimes, FaExclamationTriangle, FaCheck, FaBuilding, FaYoutube, FaGooglePlay, FaAppleAlt, FaHeadset, FaExclamationCircle, FaBars, FaCheckCircle, FaRegMoneyBillAlt, FaCoins, FaHandHoldingUsd, FaRegHourglass } from "react-icons/fa";
import ScrollToTop from '../../components/layout/ScrollToTop';
import moment from 'moment-timezone';
import { Helmet } from 'react-helmet';
import imgcoins from '../../assets/rewards/lpcoins.jpg';
import iconCoin from '../../assets/rewards/lp-coin.png';
import { ChevronRight, UserPlus, Gift } from 'lucide-react';

const BuyerDashboardNew = ({ refreshPoints }) => {
  let user = getCurrentUser();
  const [demoStatus, setDemoStatus] = useState('available');
  const [incompleteDemosCount, setIncompleteDemosCount] = useState(0);
  const [upcomingDemosCount, setUpcomingDemosCount] = useState(0);
  const [availableDemosCount, setAvailableDemosCount] = useState(0);
  const [rescheduledDemosCount, setRescheduledDemosCount] = useState(0);
  const [completedDemosCount, setCompletedDemosCount] = useState(0);
  const [verificationSuccess, setVerificationSuccess] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [showVerificationError, setShowVerificationError] = useState(true);
  const [unreadMessages, setUnreadMessages] = useState([]);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [hasPhone, setHasPhone] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingLoaded, setOnboardingLoaded] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);
  const [companyLoaded, setCompanyLoaded] = useState(false);
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [messagesLoaded, setMessagesLoaded] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [workEmailVerified, setWorkEmailVerified] = useState(false);
  const [showUnread, setShowUnread] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showPh, setShowPh] = useState(false);
  const [showWelcomeBanner, setShowWelcomeBanner] = useState(false);
  const [demosToday, setDemosToday] = useState([]);
  const [showCheckIn, setShowCheckIn] = useState(false);
  const [showCheckInYes, setShowCheckInYes] = useState(false);
  const [showCheckInNo, setShowCheckInNo] = useState(false);
  const [showCheckInNoConfirm, setShowCheckInNoConfirm] = useState(false);
  const [declinedReasons, setDeclineReasons] = useState([]);
  const [checkin, setCheckin] = useState(null);
  const [checkinLoaded, setCheckinLoaded] = useState(false);
  const [declineReasonId, setDeclineReasonId] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [company, setCompany] = useState(null);
  const [buyerDeclinedReasons, setBuyerDeclinedReasons] = useState([]);
  const [buyerObjections, setBuyerObjections] = useState([]);
  const [hasPendingExclusiveRequest, setHasPendingExclusiveRequest] = useState(false);
  const [exclusiveRequestLoaded, setExclusiveRequestLoaded] = useState(false);
  const [availablePoints, setAvailablePoints] = useState(0);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [showFirstTimeWelcome, setShowFirstTimeWelcome] = useState(false);
  const [firstTimeWelcomeLoaded, setFirstTimeWelcomeLoaded] = useState(false);
  const currentDate = new Date();
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    async function loadAvailablePoints() {
      let res = await getUserAvailablePoints();

      if (res.success) {
        setAvailablePoints(res.data);
      }
    }

    async function checkFirstTimeWelcome() {
      // Check if user has seen the welcome banner before
      const hasSeenWelcome = localStorage.getItem('leadrpro_seen_welcome_banner');
      if (!hasSeenWelcome && loaded) {
        setShowFirstTimeWelcome(true);
      }
      setFirstTimeWelcomeLoaded(true);
    }

    async function checkExclusiveRequest() {
      let res = await hasExclusiveRequest();
      if (res.success) {
        if (res.data === true) {
          setHasPendingExclusiveRequest(true);
        } else {
          setHasPendingExclusiveRequest(false);
        }
      }

      setExclusiveRequestLoaded(true);
    }

    async function fetchBuyerObjections() {
      let data = await getBuyerObjections();
      if (data.success) {
        setBuyerObjections(data.data);
      }
    }

    async function fetchBuyerDeclinedReasons() {
      let data = await getBuyerDeclinedReasons();
      if (data.success) {
        setBuyerDeclinedReasons(data.data);
      }
    }

    loadAvailablePoints();
    checkExclusiveRequest();
    fetchBuyerObjections();
    fetchBuyerDeclinedReasons();
    checkFirstTimeWelcome();
  }, [loaded]);

  async function checkSiteNotification() {
    let res = await getSiteNotification('buyer_welcome');

    if (res.success) {
      if (res.data) {
        setShowWelcomeBanner(false);
      }

      else {
        //setShowWelcomeBanner(true);
      }
    }
  }


  async function loadWorkspace() {
    let res = await getBuyerWorkspace();

    if (res.success) {
      setWorkspace(res.data);
    }

    else if (res.status === 403) {
      await refresh();

      let res = await getBuyerWorkspace();

      if (res.success) {
        setWorkspace(res.data);
      }
    }
  }

  useEffect(async () => {
    if (onboardingLoaded === true && showOnboarding === false) {
      await checkSiteNotification();
    }
  }, [onboardingLoaded, showOnboarding]);

  useEffect(async () => {
    async function loadUnreadMessages() {
      let res = await getBuyerUnreadMessages();

      if (res.success) {
        if (res.data.length > 0) {
          setHasUnreadMessages(true);
          setUnreadMessages(res.data);
          setShowUnread(true);
        }

        setMessagesLoaded(true);
      } else if (res.status === 403) {
        await refresh();

        let res = await getBuyerUnreadMessages();

        if (res.success) {
          if (res.data.length > 0) {
            setHasUnreadMessages(true);
            setUnreadMessages(res.data);
            setShowUnread(true);
          }

          setMessagesLoaded(true);
        }
      } else {
        setMessagesLoaded(true);
      }
    }

    async function checkTimezone(timezone) {
      if (timezone == null || timezone == undefined || timezone == '') {
        let l_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        if (l_timezone) {
          let res = await updateUser({ timezone: l_timezone });

          if (res.status === 403) {
            await refresh();
            let res = await updateUser({ timezone: l_timezone });
          }
        }
      }
    }

    async function loadUserProfile() {
      let res = await getUserProfile();

      if (res.success) {
        setProfileLoaded(true);
        setUserProfile(res.data);
        setWorkEmailVerified(res.data.work_email_verified);
        await checkTimezone(res.data.tz);

        if (!res.data.phone_number || res.data.phone_number === '') {
          setHasPhone(false);
        } else {
          setHasPhone(true);
        }
      } else if (res.status === 403) {
        await refresh();
        let res = await getUserProfile();

        if (res.success) {
          setProfileLoaded(true);
          setUserProfile(res.data);
          setWorkEmailVerified(res.data.work_email_verified);
          await checkTimezone(res.data.tz);

          if (!res.data.phone_number || res.data.phone_number === '') {
            setHasPhone(false);
          } else {
            setHasPhone(true);
          }
        }

        else {
          navigate('/login');
        }
      }
    }

    async function loadUserCompany() {
      let res = await getUserCompany();

      if (res.success) {
        setCompanyLoaded(true);
        setHasCompany(true);
        setCompany(res.data);
      } else if (res.status === 403) {

        await refresh();
        let res = await getUserCompany();

        if (res.success) {
          setCompanyLoaded(true);
          setHasCompany(true);
          setCompany(res.data);
        } else {
          setCompanyLoaded(true);
          setHasCompany(false);
        }
      } else {
        setCompanyLoaded(true);
        setHasCompany(false);
      }
    }

    async function loadDeclineReasons() {
      let res = await getBuyerDeclinedReasons();

      if (res.success) {
        setDeclineReasons(res.data);
      }

      else if (res.status === 403) {
        await refresh();

        let res = await getBuyerDeclinedReasons();

        if (res.success) {
          setDeclineReasons(res.data);
        }
      }
    }

    async function loadCheckIn() {
      let res = await getDemoCheckIn();

      if (res.success) {
        setCheckinLoaded(true);

        if (res.data.length > 0) {
          setCheckin(res.data[0]);
          setShowCheckIn(true);
        }
      }

      else if (res.status === 403) {
        await refresh();

        let res = await getDemoCheckIn();

        if (res.success) {
          setCheckinLoaded(true);

          if (res.data.length > 0) {
            setCheckin(res.data[0]);
            setShowCheckIn(true);
          }
        }
      }
    }

    await loadUnreadMessages();
    await loadUserProfile();
    await loadUserCompany();
    await loadDeclineReasons();
    await loadCheckIn();
    await loadWorkspace();
  }, []);

  useEffect(() => {
    if (companyLoaded === true && profileLoaded === true && userProfile) {
      setOnboardingLoaded(true);

      if (hasCompany === false) {
        setShowOnboarding(true);
      } else {
        setShowOnboarding(false);
      }
    }
  }, [companyLoaded, profileLoaded, hasCompany, userProfile]);

  useEffect(async () => {

    async function checkIsVerified() {
      let res = await isVerified();

      if (res.success) {
        if (res.data === true) setShowVerificationError(false);
        else setShowVerificationError(true);
        setLoaded(true);
      }
    }

    checkIsVerified();
  }, []);


  function setStatus(status) {
    setDemoStatus(status);
  }

  async function handleVerificationClick() {
    let _res = await resendEmailVerification();

    if (_res.success) {
      setVerificationSuccess(true);
    }
  }

  async function handleCheckInYes() {
    let res = await addDemoCheckIn(checkin.demo_id, 'Yes', null);

    if (res.success) {
      setShowCheckIn(false);
      setShowCheckInYes(true);
    }

    else if (res.status === 403) {
      await refresh();

      let res = await addDemoCheckIn(checkin.demo_id, 'Yes', null);

      if (res.success) {
        setShowCheckIn(false);
        setShowCheckInYes(true);
      }
    }
  }

  async function handleCheckInNo() {
    setShowCheckIn(false);
    setShowCheckInNo(true);
  }

  async function handleSubmitCheckInNo() {
    let res = await addDemoCheckIn(checkin.demo_id, 'No', declineReasonId);

    if (res.success) {
      setShowCheckIn(false);
      setShowCheckInNoConfirm(true);
    }

    else if (res.status === 403) {
      await refresh();

      let res = await addDemoCheckIn(checkin.demo_id, 'No', declineReasonId);

      if (res.success) {
        setShowCheckIn(false);
        setShowCheckInNoConfirm(true);
      }
    }
  }

  async function handleCheckInMaybe() {
    let res = await addDemoCheckIn(checkin.demo_id, 'Later', null);

    if (res.success) {
      setShowCheckIn(false);
    }

    else if (res.status === 403) {
      await refresh();

      let res = await addDemoCheckIn(checkin.demo_id, 'Later', null);

      if (res.success) {
        setShowCheckIn(false);
      }
    }
  }

  async function setSelectedDeclineReason(item) {
    setDeclineReasonId(item);
  }

  async function handleCheckInNoBack() {
    setShowCheckInNo(false);
    setShowCheckIn(true);
  }

  async function handleRedeemReward() {
    navigate('/dashboard/redeem');
    //setShowRedeemModal(true);
  }

  function dismissWelcomeBanner() {
    setShowFirstTimeWelcome(false);
    localStorage.setItem('leadrpro_seen_welcome_banner', 'true');
  }

  return (
    <div className='buyerdashboardnew'>
      <ScrollToTop />

      <Helmet>
        <title>LeadrPro - My Dashboard</title>
      </Helmet>
      {(onboardingLoaded === false && (
        <Spinner />
      ))}

      <div className=''>

        {showOnboarding === false && onboardingLoaded === true && (
          <>
            <button className="btn mr-30 sellerdashboard__btn-links" onClick={() => setShowWelcomeBanner(true)}><FaBars /> Quick Links</button>

            <h1 className='buyerdashboard__h1'>Dashboard</h1>

            {showVerificationError && loaded === true && onboardingLoaded && showOnboarding === false && (
              <div className="mb-6 bg-orange-50 border-l-4 border-orange-500 rounded-lg shadow-sm">
                {verificationSuccess === false ? (
                  <div className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="flex-shrink-0">
                          <FaExclamationTriangle className="h-5 w-5 text-orange-400" />
                        </div>
                        <div>
                          <p className="text-sm text-orange-800 font-medium">
                            Verify your email address to unlock all features
                          </p>
                        </div>
                        <div className="flex items-center bg-orange-100 px-2 py-1 rounded-full border border-orange-200">
                          <img src={iconCoin} alt="" className="h-4 w-4 mr-1" />
                          <span className="text-xs font-medium text-orange-800">+1</span>
                        </div>
                      </div>
                      <button
                        onClick={handleVerificationClick}
                        className="ml-4 inline-flex items-center px-3 py-1.5 border border-orange-300 text-xs font-medium rounded-full text-orange-700 bg-orange-100 hover:bg-orange-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
                      >
                        Resend verification email
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="p-4">
                    <p className="text-sm text-orange-800">
                      Please check your inbox and follow instructions in verification email.
                    </p>
                  </div>
                )}
              </div>
            )}

             {/* Progress Banner */}
            {loaded && (
              <div className="mb-6 bg-gradient-to-r from-purple-600 via-purple-700 to-indigo-700 rounded-xl shadow-lg overflow-hidden">
                <div className="px-6 py-5">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <img src={iconCoin} alt="LP Coin" className="h-8 w-8" />
                      <div>
                        <h3 className="text-white font-semibold text-lg">Rewards Progress</h3>
                        <p className="text-purple-200 text-sm">
                          {availablePoints} / 200 points earned
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center space-x-2">
                        <Gift className="h-6 w-6 text-yellow-300" />
                        <span className="text-yellow-300 font-medium text-sm">Reward Goal</span>
                      </div>
                      
                      {/* Redeem Button - Only show when user qualifies */}
                      {availablePoints >= 200 && (
                        <button
                          onClick={handleRedeemReward}
                          className="px-4 py-2 bg-yellow-400 hover:bg-yellow-300 text-purple-800 font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center space-x-2 animate-pulse hover:animate-none"
                        >
                          <Gift className="h-5 w-5" />
                          <span>Redeem Reward</span>
                        </button>
                      )}
                    </div>
                  </div>
                  
                  {/* Progress Bar Container */}
                  <div className="relative">
                    <div className="w-full bg-purple-800/50 rounded-full h-4 shadow-inner">
                      <div 
                        className={`h-4 rounded-full transition-all duration-1000 ease-out relative overflow-hidden ${
                          availablePoints === 0 ? 'bg-gray-400' :
                          availablePoints < 67 ? 'bg-gradient-to-r from-red-400 to-red-500' :
                          availablePoints < 134 ? 'bg-gradient-to-r from-yellow-400 to-yellow-500' :
                          availablePoints < 200 ? 'bg-gradient-to-r from-green-400 to-green-500' :
                          'bg-gradient-to-r from-yellow-400 via-yellow-500 to-amber-500'
                        }`}
                        style={{ width: `${Math.min((availablePoints / 200) * 100, 100)}%` }}
                      >
                        {/* Animated shine effect */}
                        {availablePoints > 0 && (
                          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse"></div>
                        )}
                      </div>
                    </div>
                    
                    {/* Gift Icon at the end */}
                    <div className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-2">
                      <div className={`p-2 rounded-full border-2 transition-all duration-500 ${
                        availablePoints >= 200 
                          ? 'bg-yellow-400 border-yellow-300 animate-pulse' 
                          : 'bg-white border-purple-300'
                      }`}>
                        <Gift className={`h-4 w-4 ${
                          availablePoints >= 200 ? 'text-purple-700' : 'text-purple-500'
                        }`} />
                      </div>
                    </div>
                  </div>
                  
                  {/* Progress Text and Milestones */}
                  <div className="flex items-center justify-between mt-3 text-sm">
                    <span className="text-purple-200">
                      {availablePoints >= 200 ? '🎉 Goal Reached!' : `${200 - availablePoints} points to go`}
                    </span>
                    <span className="text-purple-200">
                      {Math.round((availablePoints / 200) * 100)}% Complete
                    </span>
                  </div>
                  
                  {/* Milestone indicators */}
                  <div className="flex justify-between mt-6 relative">
                    <div className="absolute inset-0 flex justify-between items-center px-1">
                      {[50, 100, 150, 200].map((milestone, index) => (
                        <div key={milestone} className="flex flex-col items-center">
                          <div 
                            className={`w-2 h-2 rounded-full transition-all duration-500 ${
                              availablePoints >= milestone 
                                ? 'bg-white shadow-lg' 
                                : 'bg-purple-400/50'
                            }`}
                          ></div>
                          <span className={`text-xs mt-1 transition-colors duration-500 ${
                            availablePoints >= milestone ? 'text-white font-medium' : 'text-purple-300'
                          }`}>
                            {milestone}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* <div className='buyerdashboard__header-earn'>
              <div>
                <h2>Learn and earn rewards with LeadrPro</h2>

                <p className='buyerdashboard__header-earn-copy'>
                  Top companies want to meet with you! Make money participating in paid meetings and find the B2B solutions of tomorrow. Participating is fun and easy—give your feedback on your meeting experience and we'll send you more reward opportunities!
                </p>
              </div>

              <div>
                <img src={imgcoins} alt='' />
              </div>
            </div> */}

            {/* Add Exclusive Buyers Banner */}
            {userProfile && userProfile.is_exclusive && (
              <div className="bg-gradient-to-r from-amber-900 to-yellow-700 border border-amber-600/30 rounded-lg shadow-md mb-6 mt-2">
                <div className="px-6 py-4 flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="bg-amber-500/20 p-3 rounded-full">
                      <FaUser className="h-6 w-6 text-amber-100" />
                    </div>
                    <div>
                      <div className="flex items-center space-x-2">
                        <h3 className="text-amber-50 font-semibold text-lg">Exclusive Buyers Group Member</h3>
                        <span className="px-2 py-0.5 bg-amber-600/50 text-amber-100 rounded-full text-xs font-medium">
                          Premium Access
                        </span>
                      </div>
                      <p className="text-amber-200 text-sm mt-1">
                        You have access to early software previews and enhanced rewards
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => navigate('/dashboard/exclusive')}
                    className="px-4 py-2 bg-amber-600/30 hover:bg-amber-600/40 text-amber-100 rounded-lg flex items-center space-x-2 transition-colors"
                  >
                    <FaEdit className="h-4 w-4" />
                    <span>Edit Profile</span>
                  </button>
                </div>
              </div>
            )}

            {/* Add new Exclusive Buyers Banner */}
            {hasPendingExclusiveRequest == false && exclusiveRequestLoaded && onboardingLoaded && showOnboarding === false && loaded == true && userProfile.is_exclusive == false && (
              <div className="bg-gradient-to-r from-amber-800 to-yellow-600 border border-amber-700/30 rounded-lg shadow-md mb-6 mt-2">
                <div className="px-6 py-4 flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="bg-white/10 p-3 rounded-full">
                      <UserPlus className="h-6 w-6 text-amber-100" />
                    </div>
                    <div>
                      <div className="flex items-center space-x-2">
                        <h3 className="text-white font-semibold text-lg">Join Our Exclusive Buyers Group</h3>
                        <span className="px-2 py-0.5 bg-amber-700/50 text-amber-100 rounded-full text-xs font-medium">
                          Limited Spots
                        </span>
                      </div>
                      <p className="text-amber-100 text-sm mt-1">
                        Get early access to premium software, exclusive deals, and more.
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => navigate('/dashboard/exclusive')}
                    className="px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg flex items-center space-x-2 transition-colors"
                  >
                    <span>Apply Now</span>
                    <ChevronRight className="h-4 w-4" />
                  </button>
                </div>
              </div>
            )}

            {loaded == true && onboardingLoaded && showOnboarding == false && workspace && workspace.rescheduled_demos_pending != '0' && (
              <div className="bg-gradient-to-r from-orange-50 to-orange-100 border border-orange-200 rounded-lg shadow-sm mb-6 mt-2">
                <div className="flex items-center justify-between w-full p-4">
                  <div className="flex items-center">
                    <div className="bg-orange-500 rounded-full p-2 mr-4">
                      <FaRegCalendarTimes className="text-white w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-medium text-base text-orange-800">Reschedule Request Pending</h3>
                      <p className="text-sm text-orange-700">
                        A vendor has requested to reschedule their demo with you
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => setStatus('rescheduled')}
                    className="inline-flex items-center px-3 py-2 rounded-md border border-orange-300 bg-white text-sm font-medium text-orange-700 hover:bg-orange-50 transition-colors"
                  >
                    Submit New Times
                    <ChevronRight className="ml-2 h-4 w-4" />
                  </button>
                </div>
              </div>
            )}

            <div className='dashboard__notifications'>

              {loaded == true && onboardingLoaded && showOnboarding == false && workspace && parseInt(workspace.upcoming_demos) > 0 && (
                <div className='dashboard__notification-card' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => {
                  setStatus('upcoming')
                }}>
                  <span className='dashboard__notification-card-count'>
                    <span className='ml-10'>{workspace.upcoming_demos}</span>
                  </span>

                  <span className='ml-20' style={{ marginLeft: '20px', borderLeft: 'solid 1px #ccc', paddingLeft: '20px' }}>
                    {`Upcoming demo${parseInt(workspace.upcoming_demos) > 1 ? 's' : ''}`}
                  </span>
                </div>
              )}

              {loaded == true && onboardingLoaded && showOnboarding == false && workspace && workspace.needs_feedback != '0' && (
                <div className='dashboard__notification-card' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => {
                  setStatus('incomplete')
                }}>
                  <span className='dashboard__notification-card-count'>
                    <span className='ml-10'>{workspace.needs_feedback}</span>
                  </span>

                  <span style={{ marginLeft: '20px', borderLeft: 'solid 1px #ccc', paddingLeft: '20px' }}>
                    {`Completed (Need feedback)`}
                  </span>
                </div>
              )}
            </div>

            {demosToday.length > 0 && (
              <div>
                <div><strong>Demos Scheduled For Today</strong></div>

                {demosToday.map(item => (
                  <div className='dashboarddemo__today'>
                    <div className='dashboarddemo__today-logo'>
                      <div className='dashboarddemo__company-logo'>
                        <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.logo} />
                      </div>

                      <div style={{ marginLeft: '10px' }}>
                        Demo with {item.company_name}
                      </div>
                    </div>

                    {item.demo_date && (
                      <div className='dashboarddemo__today-date'>
                        <strong>Scheduled for:</strong>
                        <div style={{ marginBottom: '10px' }}>
                          {new Date(
                            item.demo_date
                          ).toLocaleDateString()}{' '}
                          at{' '}
                          {new Date(
                            item.demo_date
                          ).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}

                          <div>{moment.tz.guess()}</div>
                        </div>
                      </div>
                    )}

                    <div className='dashboarddemo__today-status'>
                      {item.demo_status === 'Pending' && (
                        <a target='_blank' href={`https://meetings.leadrpro.com/demo?refid=${item.reference_id}`}>
                          <span className='btn btn--primary'><span style={{ verticalAlign: 'middle', display: 'inline-block' }}><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512" style={{ fill: 'white' }}><path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z" /></svg></span>{' '}<span style={{ verticalAlign: 'middle', display: 'inline-block' }}>Join</span></span>
                        </a>
                      )}

                      {item.demo_status === 'Completed' && (
                        <>
                          <span className='dashboarddemo__status-completed'>Completed</span>
                          <br />
                          <a target='_blank' className='link' href={`https://meetings.leadrpro.com/demo?refid=${item.reference_id}`}>
                            <span>Need to rejoin?</span>
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div>
              <div>
                <div className='dashboard__demo-options-container' style={{ marginTop: '20px' }}>
                  <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'available'
                    ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                    : 'text-gray-600 hover:text-purple-600'
                    }`}
                    onClick={() => setStatus('available')}>
                    <span className='dashboard__demo-option-icon'><FaRegComments /></span> <span>Available demos</span>

                    {availableDemosCount > 0 && (
                      <span className='dashboarddemo__flag-incomplete'></span>
                    )}
                  </div>

                  {loaded && workspace && workspace.pending_demos != '0' && (
                    <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'pending'
                      ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                      : 'text-gray-600 hover:text-purple-600'
                      }`}
                      onClick={() => setStatus('pending')}>
                      <span className='dashboard__demo-option-icon'><FaRegHourglass /></span> <span>Pending</span>
                    </div>
                  )}

                  {loaded && workspace && workspace.upcoming_demos != '0' && (
                    <div
                      className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'upcoming'
                        ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                        : 'text-gray-600 hover:text-purple-600'
                        }`}
                      onClick={() => setStatus('upcoming')}>
                      <span className='dashboard__demo-option-icon'><FaRegCalendarAlt /></span> 
                      <span>Upcoming</span>
                      <span className="ml-2 px-2 py-0.5 bg-purple-100 text-purple-600 rounded-full text-xs">
                        {workspace.upcoming_demos}
                      </span>

                      {upcomingDemosCount > 0 && (
                        <span className='dashboarddemo__flag-incomplete'></span>
                      )}
                    </div>
                  )}

                  {loaded && workspace && workspace.rescheduled_demos != '0' && (
                    <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'rescheduled'
                      ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                      : 'text-gray-600 hover:text-purple-600'
                      }`}
                      onClick={() => setStatus('rescheduled')}>
                      <span className='dashboard__demo-option-icon'><FaRegCalendarTimes /></span> 
                      <span>Rescheduling</span>
                      <span className="ml-2 px-2 py-0.5 bg-purple-100 text-purple-600 rounded-full text-xs">
                        {workspace.rescheduled_demos}
                      </span>

                      {rescheduledDemosCount > 0 && (
                        <span className='dashboarddemo__flag-incomplete'></span>
                      )}
                    </div>
                  )}

                  {loaded && workspace && workspace.needs_feedback != '0' && (
                    <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'incomplete'
                      ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                      : 'text-gray-600 hover:text-purple-600'
                      }`}
                      onClick={() => setStatus('incomplete')}>
                      <span className='dashboard__demo-option-icon'><FaRegEdit /></span> 
                      <span>{'Needs Feedback'}</span>
                      <span className="ml-2 px-2 py-0.5 bg-purple-100 text-purple-600 rounded-full text-xs">
                        {workspace.needs_feedback}
                      </span>

                      {incompleteDemosCount > 0 && (
                        <span className='dashboarddemo__flag-incomplete'></span>
                      )}
                    </div>
                  )}

                  {loaded && workspace && workspace.completed_demos != '0' && (
                    <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'completed'
                      ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                      : 'text-gray-600 hover:text-purple-600'
                      }`}
                      onClick={() => setStatus('completed')}>
                      <span className='dashboard__demo-option-icon'><FaRegCalendarCheck /></span> 
                      <span>Completed</span>
                      <span className="ml-2 px-2 py-0.5 bg-purple-100 text-purple-600 rounded-full text-xs">
                        {workspace.completed_demos}
                      </span>
                    </div>
                  )}

                </div>

                <div className=''>
                  <div className='dashboard__left-side'>
                    {loaded && demoStatus === 'upcoming' && (
                      <FadeIn duration={300} delay={150}>
                        <BuyerDemosUpcoming buyerDeclinedReasons={buyerDeclinedReasons} />
                      </FadeIn>
                    )}

                    {loaded && demoStatus === 'rescheduled' && (
                      <FadeIn duration={300} delay={150}>
                        <BuyerDemosRescheduled buyerDeclinedReasons={buyerDeclinedReasons} />
                      </FadeIn>
                    )}

                    {demoStatus === 'available' && (
                      <FadeIn duration={300} delay={150}>
                        <BuyerDemosAvailable buyerDeclinedReasons={buyerDeclinedReasons} refreshPoints={refreshPoints} />
                      </FadeIn>
                    )}

                    {loaded && demoStatus === 'incomplete' && (
                      <FadeIn duration={300} delay={150}>
                        <BuyerDemosIncomplete buyerObjections={buyerObjections} />
                      </FadeIn>
                    )}

                    {loaded && demoStatus === 'completed' && (
                      <FadeIn duration={300} delay={150}>
                        <BuyerDemosCompleted />
                      </FadeIn>
                    )}

                    {loaded && demoStatus === 'pending' && (
                      <FadeIn duration={300} delay={150}>
                        <BuyerDemosPending />
                      </FadeIn>
                    )}
                  </div>
                </div>

              </div>

            </div>

          </>
        )}
      </div>

      {showOnboarding === true && onboardingLoaded === true && (
        <>
          <FadeIn delay={200} duration={200}>
            <div className='sellerdashboard__onboarding'>
              <h2>One last step before you can book demos</h2>

              <p className='sellerdashboard__onboarding-subtext'>
                Be sure to complete all of the following steps before your
                account goes live!
              </p>

              <div>

                {hasCompany === false && (
                  <>
                    <div className='sellerdashboard__onboarding-item'>
                      <div>
                        <div><strong>Complete your company profile</strong></div>
                        <div className='sellerdashboard__onboarding-description'>
                          Your company name, description, website, etc
                        </div>
                      </div>

                      <span>
                        <a
                          href='/account/company'
                          className='sellerdashboard__onboarding-btn'>
                          Start
                        </a>
                      </span>
                    </div>
                  </>
                )}
              </div>

              <div>
                <div className='sellerdashboard__onboarding-item'>
                  {workEmailVerified === false && (
                    <>
                      <div>
                        <div><strong>Verify your work email {'(1-2 min)'}</strong></div>

                        <div className='sellerdashboard__onboarding-description'>
                          A 1-time step needed to verify the email used for your work.
                        </div>
                      </div>

                      <span>
                        <Link
                          to='/account/work-email'
                          className='sellerdashboard__onboarding-btn'>
                          Start
                        </Link>
                      </span>
                    </>
                  )}

                  {workEmailVerified && (
                    <>
                      <div>
                        <span>Verify your work email</span>
                        <div className='sellerdashboard__onboarding-description'>
                          Enter a valid work email in order to participate in a demos
                        </div>
                      </div>
                      <span className='sellerdashboard__onboarding-done'>
                        Done
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </FadeIn>
        </>
      )}

      {showRescheduleModal && onboardingLoaded && showOnboarding == false && showCheckIn === false && showCheckInNo === false && (
        <FadeIn delay={200} duration={300}>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowRescheduleModal(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Reschedule Request</h2>
            <div>
              <div className='mt-20'>
                You have a reschedule request pending. <span className='link' onClick={() => {
                  setShowRescheduleModal(false);
                  setStatus('rescheduled')
                }}>Click here</span> to submit new times.
              </div>
            </div>
          </div>
        </FadeIn>
      )}

      {onboardingLoaded && showOnboarding === false && showWelcomeBanner && (
        <FadeIn delay={100} duration={300}>
          <div className='overlay'></div>
          <div className='modal max-w-5xl p-6 bg-white rounded-xl shadow-2xl min-w-[70%]' style={{ marginLeft: '-35%' }}>
            <div className='flex justify-between items-center border-b border-gray-200 pb-4'>
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-purple-100 rounded-full">
                  <FaRegCheckCircle className="w-6 h-6 text-purple-600" />
                </div>
                <h2 className='text-2xl font-bold text-gray-900'>
                  Welcome to LeadrPro
                </h2>
              </div>
              <button
                onClick={() => setShowWelcomeBanner(false)}
                className='text-gray-400 hover:text-gray-500 transition-colors'>
                <FaTimes className='w-5 h-5' />
              </button>
            </div>

            <div className='mt-6 space-y-8'>
              {/* Introduction Section */}
              <div className='bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg p-6'>
                <h3 className='text-lg font-medium text-purple-900 mb-3'>
                  Your Dashboard at a Glance
                </h3>
                <p className='text-purple-800'>
                  This is your central hub for managing demos, earnings, and interactions with vendors. Get started by exploring these key features:
                </p>
                <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mt-4'>
                  <div className='bg-white p-4 rounded-lg shadow-sm'>
                    <div className='flex items-start space-x-3'>
                      <div className='p-2 bg-green-100 rounded-full'>
                        <FaRegCalendarCheck className='w-5 h-5 text-green-600' />
                      </div>
                      <div>
                        <h4 className='font-medium text-gray-900'>Schedule Demos</h4>
                        <p className='text-sm text-gray-500'>Browse and book product demonstrations that match your interests</p>
                      </div>
                    </div>
                  </div>
                  <div className='bg-white p-4 rounded-lg shadow-sm'>
                    <div className='flex items-start space-x-3'>
                      <div className='p-2 bg-blue-100 rounded-full'>
                        <FaRegEnvelopeOpen className='w-5 h-5 text-blue-600' />
                      </div>
                      <div>
                        <h4 className='font-medium text-gray-900'>Communication</h4>
                        <p className='text-sm text-gray-500'>Manage messages and stay in touch with vendors</p>
                      </div>
                    </div>
                  </div>
                  <div className='bg-white p-4 rounded-lg shadow-sm'>
                    <div className='flex items-start space-x-3'>
                      <div className='p-2 bg-yellow-100 rounded-full'>
                        <FaHandHoldingUsd className='w-5 h-5 text-yellow-600' />
                      </div>
                      <div>
                        <h4 className='font-medium text-gray-900'>Earn Rewards</h4>
                        <p className='text-sm text-gray-500'>Get paid for your valuable feedback and participation</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Setup Checklist */}
              <div>
                <div className='flex items-center space-x-2 mb-4'>
                  <FaCheckCircle className='w-5 h-5 text-green-500' />
                  <h3 className='text-lg font-medium text-gray-900'>Complete Your Setup</h3>
                </div>
                <div className='space-y-3'>
                  <div
                    onClick={() => navigate('/account/profile')}
                    className='flex items-center justify-between p-4 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors'>
                    <div className='flex items-center space-x-4'>
                      <div className='w-12 h-12 flex items-center justify-center rounded-full bg-purple-100'>
                        <FaUser className='w-6 h-6 text-purple-500' />
                      </div>
                      <div>
                        <h4 className='font-medium text-gray-900'>Personal Profile</h4>
                        <p className='text-sm text-gray-500'>Complete your profile details</p>
                        <div className='text-xs text-purple-600 mt-1'>
                          {(!userProfile?.first_name || !userProfile?.job_title) ? 'Required: Add name and job title' : 'Complete'}
                        </div>
                      </div>
                    </div>
                    {(userProfile?.first_name && userProfile?.job_title) ? (
                      <div className='bg-green-100 p-2 rounded-full'>
                        <FaCheck className='w-4 h-4 text-green-600' />
                      </div>
                    ) : (
                      <ChevronRight className='w-5 h-5 text-gray-400' />
                    )}
                  </div>

                  <div
                    onClick={() => navigate('/account/company/edit')}
                    className='flex items-center justify-between p-4 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors'>
                    <div className='flex items-center space-x-4'>
                      <div className='w-12 h-12 flex items-center justify-center rounded-full bg-orange-100'>
                        {(company.logo == null || company.logo.length == 0) ? (
                          <FaBuilding className='w-6 h-6 text-orange-500' />
                        ) : (
                          <img
                            className='w-10 h-10 rounded-full object-cover'
                            src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + company.logo}
                            alt='Company logo'
                          />
                        )}
                      </div>
                      <div>
                        <h4 className='font-medium text-gray-900'>Company Profile</h4>
                        <p className='text-sm text-gray-500'>Add your company details to enhance your profile</p>
                        <div className='text-xs text-orange-600 mt-1'>
                          {(company.logo == null || company.logo.length == 0) ? 'Required: Add company logo' : 'Complete'}
                        </div>
                      </div>
                    </div>
                    {(company.logo != null && company.logo.length > 0) ? (
                      <div className='bg-green-100 p-2 rounded-full'>
                        <FaCheck className='w-4 h-4 text-green-600' />
                      </div>
                    ) : (
                      <ChevronRight className='w-5 h-5 text-gray-400' />
                    )}
                  </div>

                  <div
                    onClick={() => navigate('/account/workhours')}
                    className='flex items-center justify-between p-4 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors'>
                    <div className='flex items-center space-x-4'>
                      <div className='w-12 h-12 flex items-center justify-center rounded-full bg-blue-100'>
                        <FaClock className='w-6 h-6 text-blue-500' />
                      </div>
                      <div>
                        <h4 className='font-medium text-gray-900'>Availability</h4>
                        <p className='text-sm text-gray-500'>Set your preferred meeting hours</p>
                        <div className='text-xs text-blue-600 mt-1'>
                          Helps vendors schedule at convenient times
                        </div>
                      </div>
                    </div>
                    <ChevronRight className='w-5 h-5 text-gray-400' />
                  </div>
                </div>
              </div>

              {/* Quick Access Tools */}
              <div className='border-t border-gray-200 pt-6'>
                <h3 className='text-lg font-medium text-gray-900 mb-4'>Quick Access Tools</h3>
                <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
                  <a href="https://play.google.com/store/apps/details?id=com.leadrpro.mobile"
                    target="_blank"
                    className='group flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors'>
                    <FaGooglePlay className='w-8 h-8 text-green-600 mb-2' />
                    <span className='text-sm font-medium text-gray-900'>Android App</span>
                    <span className='text-xs text-gray-500'>Get it on Play Store</span>
                  </a>

                  <a href="https://apps.apple.com/us/app/leadrpro/id6449265881"
                    target="_blank"
                    className='group flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors'>
                    <FaAppleAlt className='w-8 h-8 text-gray-900 mb-2' />
                    <span className='text-sm font-medium text-gray-900'>iOS App</span>
                    <span className='text-xs text-gray-500'>Download on App Store</span>
                  </a>

                  <Link to="/dashboard/inbox"
                    className='group flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors'>
                    <FaRegEnvelopeOpen className='w-8 h-8 text-blue-600 mb-2' />
                    <span className='text-sm font-medium text-gray-900'>Messages</span>
                    <span className='text-xs text-gray-500'>Check your inbox</span>
                  </Link>

                  <Link to="/leave-feedback"
                    className='group flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors'>
                    <FaHeadset className='w-8 h-8 text-purple-600 mb-2' />
                    <span className='text-sm font-medium text-gray-900'>Support</span>
                    <span className='text-xs text-gray-500'>Get help</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      )}

      {showCheckIn && (
        <FadeIn delay={100} duration={100}>
          <div className='overlay'></div>
          <div className='modal'>

            <div className=''>
              <h2 className='modal__h2'>Just Checking In!</h2>

              <p style={{ marginTop: '20px' }}>
                You recently met with <strong>{checkin.company_name}</strong> and we wanted to check in and see how things were going. Did you end up implementing/purchashing this product?
              </p>

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <div>
                  <span className='btn btn--primary btn--small' onClick={() => handleCheckInYes()}>Yes</span>
                </div>

                <div style={{ marginLeft: '10px' }}><span className='btn btn--small btn--secondary btn--cancel' style={{ backgroundColor: '#eee', color: 'black' }} onClick={() => handleCheckInNo()}>No, I did not</span></div>
              </div>

              <div className='center mt--30 mt-30' style={{ marginTop: '20px' }}>
                <span className='link link--cancel' onClick={() => handleCheckInMaybe()}>No, but still evaluating</span>
              </div>
            </div>
          </div>
        </FadeIn>
      )}

      {showCheckInYes && (
        <FadeIn delay={400} duration={400}>
          <div className='overlay'></div>

          <div className='modal'>
            <h2 className='modal__h2'>That's great!</h2>

            <p style={{ marginTop: '20px' }}>
              We'll use this information to improve your software recommendations in the future.
            </p>

            <p style={{ marginTop: '20px' }}>
              <button className='btn btn--primary btn--small' onClick={() => setShowCheckInYes(false)}>Done</button>
            </p>
          </div>
        </FadeIn>
      )}

      {showCheckInNo && (
        <FadeIn delay={100} duration={400}>
          <div className='overlay'></div>

          <div className='modal'>
            <h2 className='modal__h2'>Please select the reason</h2>

            <p style={{ marginTop: '20px' }}>
              We will use this information to improve your future matches for recommended software.
            </p>

            <p style={{ marginTop: '20px' }}>
              <select
                className='input select input_box dropdown-font'
                onChange={(e) => setSelectedDeclineReason(e.target.value)}
                name='choose reason'>
                <option value='0'>Select a reason</option>
                <>
                  {declinedReasons.length > 0 &&
                    declinedReasons.map((item) => (
                      <option value={item.decline_reason_id}>
                        {item.reason}
                      </option>
                    ))}
                </>
              </select>
            </p>

            {showCheckInNoConfirm === false && (
              <p style={{ marginTop: '20px' }}>
                <button className='btn btn--primary btn--small' onClick={() => handleSubmitCheckInNo()}>Submit</button>

                <span className='link' style={{ marginLeft: '20px' }} onClick={() => handleCheckInNoBack()}>Back</span>
              </p>
            )}

            {showCheckInNoConfirm && (
              <div style={{ marginTop: '20px' }}>
                <p style={{ color: 'green', fontSize: '12px' }}>Saved!</p>
                <p style={{ marginTop: '10px' }}>
                  <button className='btn btn--secondary btn--cancel' onClick={() => { setShowCheckInNo(false); setShowCheckIn(false) }}>Done</button>
                </p>
              </div>
            )}
          </div>
        </FadeIn>
      )}

      {loaded && showOnboarding === false && onboardingLoaded === true && (userProfile.job_title == '' || userProfile.first_name == '') && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <h2 className='modal__h2'>Update your profile</h2>

            <p className='mt-10'>
              Your profile is currently missing one or more fields {'(name, job title, seniority...)'}.
            </p>

            <p className='mt-20 center'>
              <Link to='/account/profile' className='btn btn--primary'>Update profile</Link>
            </p>
          </div>
        </>
      )}

      {showRedeemModal && (
        <FadeIn delay={100} duration={300}>
          <div className='overlay'></div>
          <div className='modal max-w-lg'>
            <div className='modal__close' onClick={() => setShowRedeemModal(false)}>
              <FaTimes />
            </div>

            <div className="text-center">
              <div className="mb-4">
                <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
                  <Gift className="h-8 w-8 text-yellow-600" />
                </div>
              </div>
              
              <h2 className='modal__h2'>Congratulations! 🎉</h2>
              
              <p className="mt-4 text-gray-600">
                You've earned <strong>{availablePoints} points</strong> and qualified for rewards!
              </p>
              
              <div className="mt-6 bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg p-4">
                <h3 className="font-semibold text-purple-900 mb-2">Available Rewards:</h3>
                <div className="space-y-2 text-sm text-purple-800">
                  <div className="flex items-center justify-between">
                    <span>💰 Cash Reward</span>
                    <span className="font-medium">$50</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span>🎁 Gift Card</span>
                    <span className="font-medium">$50 Amazon</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span>⭐ Premium Features</span>
                    <span className="font-medium">3 months</span>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 flex space-x-3">
                <button
                  onClick={() => navigate('/dashboard/rewards')}
                  className="flex-1 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors font-medium"
                >
                  View Rewards
                </button>
                <button
                  onClick={() => setShowRedeemModal(false)}
                  className="flex-1 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg transition-colors"
                >
                  Later
                </button>
              </div>
              
              <p className="mt-4 text-xs text-gray-500">
                Keep earning more points for bigger rewards!
              </p>
            </div>
          </div>
        </FadeIn>
      )}

      <div id="firsttimewelcome">
        {/* First Time Welcome Banner */}
        {showFirstTimeWelcome && firstTimeWelcomeLoaded && loaded && (
          <FadeIn delay={200} duration={500}>
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
              <div className="bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 rounded-2xl shadow-2xl overflow-hidden relative max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                {/* Background pattern */}
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600"></div>
                  <div className="absolute inset-0" style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
                  }}></div>
                </div>
                
                <div className="relative px-8 py-8">
                  {/* Header */}
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center space-x-4">
                      <div className="relative">
                        <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center shadow-lg animate-pulse">
                          <Gift className="w-8 h-8 text-purple-900" />
                        </div>
                        <div className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center animate-bounce">
                          <span className="text-white text-xs font-bold">!</span>
                        </div>
                      </div>
                      <div>
                        <h2 className="text-3xl font-bold text-white mb-1 bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-transparent">
                          Welcome to LeadrPro! 🎉
                        </h2>
                        <p className="text-purple-200 text-lg">Start earning rewards while learning about new software</p>
                      </div>
                    </div>
                    <button
                      onClick={dismissWelcomeBanner}
                      className="text-purple-300 hover:text-white transition-colors p-2 rounded-full hover:bg-white/10"
                    >
                      <FaTimes className="w-5 h-5" />
                    </button>
                  </div>

                  {/* Points Info */}
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-6 border border-white/20">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center space-x-3">
                        <img src={iconCoin} alt="LP Coin" className="w-10 h-10" style={{animationDuration: '3s'}} />
                        <div>
                          <h3 className="text-white font-semibold text-xl">Earn Points, Get Rewards</h3>
                          <p className="text-purple-200">Every action earns you points toward cash rewards and gift cards</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-3xl font-bold text-yellow-400">{availablePoints}</div>
                        <div className="text-purple-200 text-sm">Current Points</div>
                      </div>
                    </div>
                    
                    <div className="bg-purple-800/30 rounded-lg p-4">
                      <div className="flex items-center justify-between text-sm mb-2">
                        <span className="text-purple-200">Progress to first reward</span>
                        <span className="text-white font-medium">{availablePoints}/200 points</span>
                      </div>
                      <div className="w-full bg-purple-900/50 rounded-full h-3">
                        <div 
                          className="h-3 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 transition-all duration-1000 relative overflow-hidden"
                          style={{ width: `${Math.min((availablePoints / 200) * 100, 100)}%` }}
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-pulse"></div>
                        </div>
                      </div>
                      <div className="flex justify-between mt-2 text-xs text-purple-300">
                        <span>Start</span>
                        <span className="text-yellow-300 font-medium">🎁 $50 Reward</span>
                      </div>
                    </div>
                  </div>

                  {/* Ways to Earn Points */}
                  <div className="mb-6">
                    <h3 className="text-2xl font-bold text-white mb-4 text-center">
                      💰 Ways to Earn Points
                    </h3>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
                        <div className="flex items-center space-x-3 mb-3">
                          <div className="w-12 h-12 bg-green-500/20 rounded-lg flex items-center justify-center">
                            <FaRegCalendarCheck className="w-6 h-6 text-green-300" />
                          </div>
                          <div>
                            <h4 className="text-white font-semibold">Book & Attend Demos</h4>
                            <div className="flex items-center space-x-1">
                              <img src={iconCoin} alt="" className="w-4 h-4" />
                              <span className="text-green-300 font-bold">+295 points</span>
                            </div>
                          </div>
                        </div>
                        <p className="text-purple-200 text-sm">Schedule and participate in product demonstrations</p>
                      </div>

                      {/* <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
                        <div className="flex items-center space-x-3 mb-3">
                          <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center">
                            <FaRegEdit className="w-6 h-6 text-blue-300" />
                          </div>
                          <div>
                            <h4 className="text-white font-semibold">Complete Feedback</h4>
                            <div className="flex items-center space-x-1">
                              <img src={iconCoin} alt="" className="w-4 h-4" />
                              <span className="text-blue-300 font-bold">+50 points</span>
                            </div>
                          </div>
                        </div>
                        <p className="text-purple-200 text-sm">Share detailed thoughts after each demo session</p>
                      </div> */}

                      {/* <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
                        <div className="flex items-center space-x-3 mb-3">
                          <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center">
                            <FaUser className="w-6 h-6 text-purple-300" />
                          </div>
                          <div>
                            <h4 className="text-white font-semibold">Complete Profile</h4>
                            <div className="flex items-center space-x-1">
                              <img src={iconCoin} alt="" className="w-4 h-4" />
                              <span className="text-purple-300 font-bold">+15 points</span>
                            </div>
                          </div>
                        </div>
                        <p className="text-purple-200 text-sm">Fill out your profile for better software matches</p>
                      </div> */}

                      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
                        <div className="flex items-center space-x-3 mb-3">
                          <div className="w-12 h-12 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                            <FaEnvelopeOpen className="w-6 h-6 text-yellow-300" />
                          </div>
                          <div>
                            <h4 className="text-white font-semibold">Verify Email</h4>
                            <div className="flex items-center space-x-1">
                              <img src={iconCoin} alt="" className="w-4 h-4" />
                              <span className="text-yellow-300 font-bold">+1 points</span>
                            </div>
                          </div>
                        </div>
                        <p className="text-purple-200 text-sm">Verify your work email address</p>
                      </div>

                      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
                        <Link to='/account/refer-a-friend'>
                        <div className="flex items-center space-x-3 mb-3">
                          <div className="w-12 h-12 bg-orange-500/20 rounded-lg flex items-center justify-center">
                            <FaUsers className="w-6 h-6 text-orange-300" />
                          </div>
                          <div>
                            <h4 className="text-white font-semibold">Referrals</h4>
                            <div className="flex items-center space-x-1">
                              <img src={iconCoin} alt="" className="w-4 h-4" />
                              <span className="text-orange-300 font-bold">+200 points</span>
                            </div>
                          </div>
                        </div>
                        </Link>
                        <p className="text-purple-200 text-sm">Invite colleagues to join LeadrPro</p>
                      </div>

                      {/* <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:scale-105">
                        <div className="flex items-center space-x-3 mb-3">
                          <div className="w-12 h-12 bg-pink-500/20 rounded-lg flex items-center justify-center">
                            <FaRegComments className="w-6 h-6 text-pink-300" />
                          </div>
                          <div>
                            <h4 className="text-white font-semibold">Active Engagement</h4>
                            <div className="flex items-center space-x-1">
                              <img src={iconCoin} alt="" className="w-4 h-4" />
                              <span className="text-pink-300 font-bold">+5-20 points</span>
                            </div>
                          </div>
                        </div>
                        <p className="text-purple-200 text-sm">Regular platform usage and participation</p>
                      </div> */}
                    </div>
                  </div>

                  {/* Call to Action */}
                  <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl p-6 text-center shadow-2xl">
                    <h3 className="text-purple-900 font-bold text-2xl mb-2">🚀 Ready to Start Earning?</h3>
                    <p className="text-purple-800 mb-4 text-lg">Browse available demos and start your reward journey today!</p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                      <button
                        onClick={() => {
                          dismissWelcomeBanner();
                          setStatus('available');
                        }}
                        className="px-8 py-3 bg-purple-900 hover:bg-purple-800 text-white font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center justify-center space-x-2"
                      >
                        <FaRegComments className="w-5 h-5" />
                        <span>Browse Available Demos</span>
                      </button>
                      <button
                        onClick={() => {
                          dismissWelcomeBanner();
                          navigate('/account/profile');
                        }}
                        className="px-8 py-3 bg-white/20 hover:bg-white/30 text-white font-bold rounded-lg transition-all duration-300 border border-white/30 flex items-center justify-center space-x-2"
                      >
                        <FaUser className="w-5 h-5" />
                        <span>Complete Profile</span>
                      </button>
                    </div>
                    <p className="mt-4 text-purple-800 text-sm">
                      💡 Tip: Complete your profile first to get better demo matches!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        )}
      </div>
    </div>
  );
};

export default BuyerDashboardNew;
